interface Props {
  modal: {
    content: React.ReactNode;
    title?: string;
    size?: 'sm' | 'md' | 'lg';
  } | null;
  onClose: () => void;
}

export const ModalContainer = ({ modal, onClose }: Props) => {
  if (!modal) return null;

  const sizeClass =
    modal.size === 'sm'
      ? 'app-modal-sm'
      : modal.size === 'lg'
      ? 'app-modal-lg'
      : 'app-modal-md';

  const hasTitle = Boolean(modal.title);

  return (
    <>
      <div className="app-modal-backdrop" onClick={onClose} />

      <div className="app-modal-container">
        <div className={`app-modal ${sizeClass}`}>
          
          {/* <> HEADER SOLO SI HAY TÍTULO */}
          {hasTitle && (
            <div className="app-modal-header app-modal-header--success">
              <div className="app-modal-header__title">
                {modal.title}
              </div>

              <button
                className="app-modal-close"
                onClick={onClose}
                aria-label="Cerrar modal"
              >
                ×
              </button>
            </div>
          )}

          {/* <> BOTÓN CERRAR CUANDO NO HAY HEADER */}
          {!hasTitle && (
            <button
              className="app-modal-close app-modal-close--floating"
              onClick={onClose}
              aria-label="Cerrar modal"
            >
              ×
            </button>
          )}

          <div className="app-modal-body">
            {modal.content}
          </div>
        </div>
      </div>
    </>
  );
};